module.exports = __webpack_public_path__ + "static/media/content-settings.481be7cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/assets/content-settings.svg
// module id = 573
// module chunks = 0